export default __webpack_public_path__ + "static/media/QuizIconNew.15d6ce82.svg";